import script from "./TeamsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamsTable.vue?vue&type=script&setup=true&lang=ts"

import "./TeamsTable.vue?vue&type=style&index=0&id=ff1d09c8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff1d09c8"]])

export default __exports__